module.exports = __webpack_public_path__ + "static/media/inquiry-centre.14f6cf33.png";